/* global axios */
import ApiClient from './ApiClient';

// A busca e POST porque o filtro facetado (multi-CNAE, multi-UF, faixas) nao cabe em query
// string — mesmo motivo do POST em companies/filter.
class FlipLeadsAPI extends ApiClient {
  constructor() {
    super('flip_leads', { accountScoped: true });
  }

  // `signal` REPASSADO, e nao mais um parametro de conveniencia: quem troca de filtro no meio de
  // uma busca nacional deixa para tras ate 9,7s de trabalho no banco (#1193). Sem o sinal, essa
  // consulta roda ate o fim para um resultado que ninguem vai ler; com ele, o Postgres recebe o
  // cancelamento pelo fechamento da conexao. Quem cria e cancela o controller e a action da
  // store (#1192) — este arquivo so entrega o sinal ao axios.
  search({ filters = {}, cursor = null, perPage = 25, signal } = {}) {
    return axios.post(
      `${this.url}/search`,
      {
        filters,
        cursor,
        per_page: perPage,
      },
      { signal }
    );
  }

  facets({ filters = {}, signal } = {}) {
    return axios.post(`${this.url}/facets`, { filters }, { signal });
  }

  cnaes(term) {
    return axios.get(`${this.url}/cnaes`, { params: { q: term } });
  }

  // As UFs ja marcadas no trilho vao junto: o autocomplete de municipio filtra por estado
  // porque `rf.municipios` carrega a UF materializada pelo ETL. Lista vazia = busca nacional,
  // e o servidor trata a ausencia do parametro do mesmo jeito.
  municipios(term, ufs = []) {
    return axios.get(`${this.url}/municipios`, {
      params: { q: term, uf: ufs },
    });
  }

  show(cnpj) {
    return axios.get(`${this.url}/estabelecimentos/${cnpj}`);
  }

  // POST porque cobra credito: nao pode ser retentado por prefetch nem cair em cache.
  reveal(cnpj) {
    return axios.post(`${this.url}/estabelecimentos/${cnpj}/reveal`);
  }

  // A EQUIPE pela Apollo (#1513). GET le o que a conta ja pagou, sem tocar na Apollo e sem cobrar;
  // POST compra. O `site` so vai quando a empresa nao tem dominio proprio na Receita.
  equipe(cnpj) {
    return axios.get(`${this.url}/estabelecimentos/${cnpj}/equipe`);
  }

  // POST porque cobra credito: nao pode ser retentado por prefetch nem cair em cache.
  buscarEquipe(cnpj, site = null) {
    return axios.post(
      `${this.url}/estabelecimentos/${cnpj}/equipe`,
      site ? { site } : {}
    );
  }

  // REVELAR celular e e-mail de UMA pessoa da equipe (#1514). POST porque cobra crédito — e porque
  // cobra a Apollo (8 créditos dela por chamada), então um prefetch de navegador custaria dinheiro.
  // Não há GET par: o que a conta já revelou vem embutido no `equipe(cnpj)`, que a aba já chama.
  revelarPessoa(cnpj, fonteId) {
    return axios.post(
      `${this.url}/estabelecimentos/${cnpj}/pessoas/${encodeURIComponent(
        fonteId
      )}/revelar`
    );
  }

  credits() {
    return axios.get(`${this.url}/credits`);
  }
}

export default new FlipLeadsAPI();
